module.exports = __webpack_public_path__ + "files/680d35e3c073a84a91283a283e47fb0c.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size4-Regular.woff2
// module id = 1206
// module chunks = 76